import React, { ReactNode } from 'react';

import dayjs from 'dayjs';
import styled from 'styled-components';

import Tooltip from 'components/lib/Tooltip';
import { SnapshotDataType } from 'types/snapshot';

import { getSnapshotActorName } from './helpers';

const ActorTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: normal;
  color: var(--text-primary);
`;

const ActorTooltipEntry = styled.div`
  display: flex;
  gap: 6px;
  align-items: start;
  font-size: 12px;
  span {
    white-space: nowrap;
  }
`;

const ActorTooltipLabel = styled.span`
  font-family: var(--font-bold);
  color: var(--text-primary);
  min-width: 52px;
`;

const ActorTooltipContent = styled.span`
  display: flex;
  flex-wrap: wrap;
  color: var(--text-secondary);
  gap: 4px;
`;

interface Props {
  snapshot: SnapshotDataType;
  children: ReactNode;
  showTooltip?: boolean;
}

const SnapshotActorTooltip = ({ snapshot, children, showTooltip = false }: Props) => {
  if (showTooltip) {
    return (
      <Tooltip
        title={
          <ActorTooltipContainer>
            <ActorTooltipEntry>
              <ActorTooltipLabel>Created:</ActorTooltipLabel>
              <ActorTooltipContent>
                <span>{getSnapshotActorName(snapshot?.created_by)}</span>
                <span>·</span>
                <span>{dayjs(snapshot?.created_at).format('MM/DD/YYYY hh:mm A')}</span>
              </ActorTooltipContent>
            </ActorTooltipEntry>
            <ActorTooltipEntry>
              <ActorTooltipLabel>Updated:</ActorTooltipLabel>
              <ActorTooltipContent>
                <span>{getSnapshotActorName(snapshot?.updated_by)}</span>
                <span>·</span>
                <span>{dayjs(snapshot?.updated_at).format('MM/DD/YYYY hh:mm A')}</span>
              </ActorTooltipContent>
            </ActorTooltipEntry>
          </ActorTooltipContainer>
        }
      >
        {children}
      </Tooltip>
    );
  }

  return <>{children}</>;
};

export default SnapshotActorTooltip;
